import { useEffect } from 'react';
import { useRouter } from '../../hooks/useRouter';

export const ScrollToTopOnRouteChange = () => {
  const { location } = useRouter();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};
